import { render, staticRenderFns } from "./SemPermissao.vue?vue&type=template&id=40e33a50&scoped=true&"
import script from "./SemPermissao.vue?vue&type=script&lang=js&"
export * from "./SemPermissao.vue?vue&type=script&lang=js&"
import style0 from "./SemPermissao.vue?vue&type=style&index=0&id=40e33a50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e33a50",
  null
  
)

export default component.exports